import { getProvinceListRequest } from "../../data/provinceApi";

function getPayloadData(response) {
  if (Array.isArray(response)) {
    return response;
  }

  if (Array.isArray(response?.data)) {
    return response.data;
  }

  if (Array.isArray(response?.data?.data)) {
    return response.data.data;
  }

  return [];
}

export async function getProvinceListUseCase() {
  return getPayloadData(await getProvinceListRequest());
}
